import EventEmitter from "../utils/EventEmitter";
import Hotspot from "./Hotspot";

export default class HotspotGroup extends EventEmitter {
  constructor (hotspots) {
    super();

    this.instances = hotspots;

    for (const hotspot of hotspots) {
      const _hotspot = new Hotspot(hotspot)

      _hotspot.on("click", (e) => this.handleClick(e));
    }
  }

  handleClick (hotspot) {
    this.trigger("click", [hotspot]);
  }
}